// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_yDb","cls2":"AutoCompleteResultRow-cls2_hjn AutoCompleteResultRow-cls1_yDb"};